import types from './types';

const INITIAL_STATE = {
}

const accountReducer = (state = INITIAL_STATE, action) => {
    switch(action.type) {
        default: return state;
    }
}

export default accountReducer;